var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"icon":""},on:{"click":_vm.onClick}},[_c('img',{attrs:{"src":require("@/assets/images/main/svg/buttonFilter.svg")}})])
}
var staticRenderFns = []

export { render, staticRenderFns }